import React from 'react';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useApi, identityApiRef, discoveryApiRef } from '@backstage/core-plugin-api';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed' as 'fixed',
    top: theme.spacing(1),
    right: theme.spacing(2),
    // keep it above app bar
    zIndex: (theme.zIndex && (theme.zIndex as any).appBar ? (theme.zIndex as any).appBar + 1 : 2000),
  },
}));

export default function TopBarSignOut() {
  const classes = useStyles();
  const identityApi = useApi(identityApiRef);
  const discoveryApi = useApi(discoveryApiRef);

  const handleSignOut = async () => {
    try {
      if (typeof (identityApi as any).signOut === 'function') {
        await (identityApi as any).signOut();
        return;
      }
      const base = await discoveryApi.getBaseUrl('auth');
      window.location.href = `${base}/logout`;
    } catch (e) {
      // fallback redirect on error
      console.error('Sign out failed', e);
      try {
        const base = await discoveryApi.getBaseUrl('auth');
        window.location.href = `${base}/logout`;
      } catch (_) {
        window.location.href = '/api/auth/logout';
      }
    }
  };

  return (
    <div className={classes.root}>
      <Tooltip title="Sign out">
        <IconButton color="inherit" onClick={handleSignOut} aria-label="Sign out" data-testid="topbar-signout">
          <ExitToAppIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}
